module.exports = __webpack_public_path__ + "img/retail_app.cb84ed8c.png";